var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"background-color":"#2e3b4e","text-color":"#fff","active-text-color":"#ffd04b","router":true,"default-active":_vm.defaultActive,"unique-opened":true}},_vm._l((_vm.menuList),function(menu){return _c('menu-item',{key:menu.path,attrs:{"menu":menu,"base-path":""}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }